import { render, staticRenderFns } from "./VideoBlob.vue?vue&type=template&id=5a741207&scoped=true"
import script from "./VideoBlob.vue?vue&type=script&lang=js"
export * from "./VideoBlob.vue?vue&type=script&lang=js"
import style0 from "./VideoBlob.vue?vue&type=style&index=0&id=5a741207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a741207",
  null
  
)

export default component.exports